const CurriculumExperienceBox = () => {
  return <div>Hello World from CurriculumExperienceBox</div>;
};

export default CurriculumExperienceBox;
